var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6368 15.2737H40.7264V20.3632H35.6368V15.2737Z",
    fill: "#9E9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40.7264V50.9088H50.9088V45.8176H40.7264V40.7264H45.8176V35.6368H50.9088V40.7264H56Z",
    fill: "#9E9D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09122 50.9088H50.9088V56H5.09122V50.9088Z",
    fill: "#9E9D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 45.8176H5.09122V50.9088H0V45.8176Z",
    fill: "#9E9D9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6368 40.7264V45.8176H5.09122V40.7264H10.1824V35.6368H15.2737V30.5456H25.4544V35.6368H30.5456V40.7264H35.6368Z",
    fill: "#9E9D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9088 5.09122V0H5.09122V5.09122H0V40.7264H5.09122V35.6368H10.1824V30.5456H15.2737V25.4544H25.4544V30.5456H30.5456V35.6368H35.6368V40.7264H40.7264V35.6368H45.8176V30.5456H50.9088V35.6368H56V5.09122H50.9088ZM45.8176 20.3632H40.7264V25.4544H35.6368V20.3632H30.5456V15.2737H35.6368V10.1824H40.7264V15.2737H45.8176V20.3632Z",
    fill: "#9E9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinLogo);
export default __webpack_public_path__ + "static/media/coin-logo.ee7b524e59474b91969b6d9812e02053.svg";
export { ForwardRef as ReactComponent };